import { z } from 'zod';
import { uuidSchema } from './common';

// =============================================================================
// REQUEST SCHEMAS
// =============================================================================

export const browserParams = z.object({
  hubId: uuidSchema,
  resourceId: uuidSchema,
});

export const browserFoldersQuery = z.object({
  parent_folder_id: uuidSchema.optional(),
  search: z.string().max(100).optional(),
});

export const browserFilesQuery = z.object({
  folder_id: uuidSchema.optional(),
  search: z.string().max(100).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
  offset: z.coerce.number().int().min(0).max(10000).default(0),
});

// =============================================================================
// INFERRED TYPES
// =============================================================================

export type BrowserParams = z.infer<typeof browserParams>;
export type BrowserFoldersQuery = z.infer<typeof browserFoldersQuery>;
export type BrowserFilesQuery = z.infer<typeof browserFilesQuery>;

// =============================================================================
// RESPONSE TYPES
// =============================================================================

export interface BrowserFolderItem {
  folder_id: string;
  folder_name: string;
  folder_description: string | null;
  parent_folder_id: string | null;
  metadata: Record<string, unknown>;
  file_count: number;
  subfolder_count: number;
  resource_id: string;
  resource_name: string;
}

export interface BrowserFileItem {
  file_id: string;
  file_name: string;
  file_description: string | null;
  mime_type: string | null;
  file_size: number | null;
  folder_id: string | null;
  metadata: Record<string, unknown>;
  resource_id: string;
  resource_name: string;
}

export interface BrowserFoldersResponse {
  success: boolean;
  folders: BrowserFolderItem[];
  total_count: number;
}

export interface BrowserFilesResponse {
  success: boolean;
  files: BrowserFileItem[];
  total_count: number;
}
